import React, { useState, useRef, useEffect } from "react";
import { getAllClassNames } from "helpers";
import styles from "./CustomDropdown.module.scss";
import Text from "components/text/Text";
import { Arrow, Close } from "assets/icons";
import strings from "assets/strings";
import { useClickOutside } from "hooks";

type ItemProps = {
  value: number;
  label: string;
  isSelected: boolean;
};

type IDropdownProps = {
  selectOptions: ItemProps[];
  title?: string;
  multiSelect?: boolean;
  slectedValue?: number;
  defaultValue?: number;
}

export const CustomDropdown = ({
  selectOptions,
  title,
  multiSelect,
  slectedValue,
  defaultValue,
  ...props
}: IDropdownProps) => {

  const [items, setItems] = useState(selectOptions);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState(slectedValue);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useClickOutside(dropdownRef, () => setShowDropdown(false));

  useEffect(() => {
    const updatedItems = items.map((option) => {
      if (option.value === selectedValue) {
        return {
          ...option,
          isSelected: true,
        };
      }
      return {
        ...option,
        isSelected: false,
      };
    });
    setItems(updatedItems);
  }, [selectedValue]);

  const isSelected = (value: number) => {
    return value === selectedValue;
  }

  const handleSelectedOption = (value: number): void => {
    setSelectedValue(value);
    setShowDropdown(false);
    const queryString = window.location.search;
    const urlSearchParams = new URLSearchParams(queryString);
    urlSearchParams.set("r", value.toString());
    window.location.search = urlSearchParams.toString();
  };

  const handleRemoveSelectedOption = (): void => {
    setSelectedValue(defaultValue);
    setShowDropdown(false);
    const updatedItems = items.map((option) => {
      return {
        ...option,
        isSelected: false,
      };
    });
    setItems(updatedItems);
    const queryString = window.location.search;
    const urlSearchParams = new URLSearchParams(queryString);
    urlSearchParams.set("r", defaultValue?.toString() || "");
    window.location.search = urlSearchParams.toString();

  }


  return (
    <div className={styles.container} {...props}>
      <div className={styles.divTop}>
        {title && <Text className={styles.title} text={title} />}
        {multiSelect && (
          <span
            onClick={() => setShowDropdown(true)}
            className={styles.listText}
          >
            {strings.doctorSearchResults.list}
          </span>
        )}
      </div>
      <div
        className={getAllClassNames([
          styles.dropdownContainer,
          !multiSelect && styles.paddingLeft,
        ])}
      >
        {items && items
          .filter((item) => item.isSelected)
          .map((item) => (
            <li
              key={item.value}
              className={getAllClassNames([
                styles.item,
                "ais-RefinementList-item",
                isSelected(item.value) && "ais-RefinementList-item--selected",
              ])}
            >
              <span
                className={getAllClassNames([
                  "ais-RefinementList-labelText",
                  styles.label,
                ])}
              >
                {item.label}
              </span>
              <Close
                onClick={() => handleRemoveSelectedOption()}
                className={styles.icon}
              />
            </li>
          ))}

        {!multiSelect && (
          <Arrow
            onClick={() => setShowDropdown(true)}
            className={styles.iconArrow}
          />
        )}
      </div>
      {showDropdown && (
        <div ref={dropdownRef} className={styles.dropdown}>
          <Arrow
            onClick={() => setShowDropdown(false)}
            className={styles.iconArrow}
          />
          {items.map((item) => (
            <li
              key={item.value}
              className={getAllClassNames([
                "ais-RefinementList-item",
                isSelected(item.value) && "ais-RefinementList-item--selected",
              ])}
            >
              <label
                onClick={
                  multiSelect
                    ? undefined
                    : () => {
                      handleSelectedOption(item.value);
                    }
                }
                className="ais-RefinementList-label"
              >
                {multiSelect && (
                  <input
                    className="ais-RefinementList-checkbox"
                    type="checkbox"
                    value={item.value}
                    checked={item.isSelected}
                  // onChange={() => {
                  //   refine(item.value);
                  // }}
                  />
                )}
                <span
                  className={getAllClassNames([
                    "ais-RefinementList-labelText",
                    styles.textMiddle,
                  ])}
                >
                  {item.label}
                </span>
              </label>
            </li>
          ))}
          <div className={styles.height} />
         
        </div>
      )}
    </div>
  );
};
